module.exports = __webpack_public_path__ + "/static/assets/26dd6e55be44faf9f22d93505fc206cd.gif";